module.exports = __webpack_public_path__ + "img/appointment_fail.29b1c286.png";